import { callDeleteExternalApi, callGetExternalApi, callPostExternalApi } from '@ctn/axios-util';
import { noTokenInstance } from '../constants/axios.instances.constants';
import {
	type IListadoInscripcion,
	type IDetallesInscripcion,
} from '../interfaces/model/IDetallesInscripcion.interface';

export type IPayload = {
	aplicacion: string;
	formulario: {
		name: string;
		surnames: string;
		entity: string;
		email: string;
	};
};

/**
 * Listado de rutas del backend
 */
const getBackendUrl = () => ({
	POST_INSCRIPCION: 'rest/public/inscripcion',
	GET_INSCRIPCION: 'rest/public/inscripcion/evento-inmobiliario-valencia',
	DELETE_INSCRIPCION: 'rest/public/inscripcion/evento-inmobiliario-valencia',
	GET_LISTADO_INSCRIPCIONES: 'rest/public/inscripcion-mail/evento-inmobiliario-valencia',
});

export const postInscription = async (data: IPayload) =>
	callPostExternalApi({
		axiosInstance: noTokenInstance,
		withCredentials: true,
		url: getBackendUrl().POST_INSCRIPCION,
		data,
	});
export const getInscription = async (uuid: string | number) =>
	callGetExternalApi<IDetallesInscripcion>({
		axiosInstance: noTokenInstance,
		withCredentials: false,
		url: `${getBackendUrl().GET_INSCRIPCION}/${uuid}`,
	});

export const deleteInscription = async (uuid: string | number) =>
	callDeleteExternalApi({
		axiosInstance: noTokenInstance,
		withCredentials: false,
		url: `${getBackendUrl().DELETE_INSCRIPCION}/${uuid}`,
	});

export const getListadoInscription = async () =>
	callGetExternalApi<IListadoInscripcion>({
		axiosInstance: noTokenInstance,
		withCredentials: false,
		url: `${getBackendUrl().GET_LISTADO_INSCRIPCIONES}`,
	});
